<div class="rounded-xl border border-slate-200 bg-white p-5 space-y-4">
    <!-- Enable toggle (modern switch) -->
    <div class="flex items-start justify-between gap-4">
        <div class="flex-1">
            <p class="text-sm font-medium text-slate-900">{{ enabledLabel }}</p>
            @if (description) {
            <p class="text-xs text-slate-500 mt-1 leading-relaxed">{{ description }}</p>
            }
        </div>
        <label class="relative inline-flex items-center cursor-pointer shrink-0 mt-0.5">
            <input type="checkbox" class="sr-only peer" [checked]="enabled()"
                (change)="toggleEnabled($any($event.target).checked)" />
            <div
                class="w-11 h-6 bg-slate-200 rounded-full transition-colors peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-100 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:h-5 after:w-5 after:rounded-full after:bg-white after:border after:border-slate-300 after:transition-all peer-checked:after:translate-x-5 peer-checked:after:border-white">
            </div>
        </label>
    </div>

    @if (enabled()) {
    <div class="space-y-4 border-t border-slate-100 pt-4">
        <!-- From / To -->
        <div class="grid grid-cols-2 gap-3 max-w-xs">
            <div>
                <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">From</label>
                <input type="time" [value]="start()" (input)="setStart($any($event.target).value)"
                    class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
            </div>
            <div>
                <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">To</label>
                <input type="time" [value]="end()" (input)="setEnd($any($event.target).value)"
                    class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
            </div>
        </div>

        @if (!isValid) {
        <p class="text-xs text-red-600">Both start and end times are required.</p>
        }
        @if (isOvernight) {
        <p class="text-xs text-amber-600">End is at or before start — treated as an overnight window that crosses
            midnight.</p>
        }

        <!-- Day chips -->
        <div>
            <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">Days</label>
            <div class="flex flex-wrap gap-2">
                @for (d of days; track d.key) {
                <button type="button" (click)="toggleDay(d.key)"
                    class="px-3 py-1.5 rounded-full text-xs font-medium border transition-colors"
                    [class.bg-blue-600]="isDaySelected(d.key)"
                    [class.text-white]="isDaySelected(d.key)"
                    [class.border-blue-600]="isDaySelected(d.key)"
                    [class.bg-white]="!isDaySelected(d.key)"
                    [class.text-slate-600]="!isDaySelected(d.key)"
                    [class.border-slate-200]="!isDaySelected(d.key)"
                    [class.hover:bg-slate-50]="!isDaySelected(d.key)">
                    {{ d.label }}
                </button>
                }
            </div>
            <p class="text-xs text-slate-400 mt-1.5">Leave all days unselected to apply every day.</p>
        </div>
    </div>
    }
</div>
